import { AppSettingsModel } from '../models/admin/app-settings.model';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  private httpClient: HttpClient;
  private appSettings: AppSettingsModel;

  constructor(handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  getProviderIdentity() {
    return this.appSettings.PROVIDER_IDENTITY;
  }

  getApiEndpointAdmin() {
    return this.appSettings.API_ENDPOINT_DASHBOARD;
  }

  getApiEndpointValidator() {
    return this.appSettings.API_ENDPOINT_VALIDATOR;
  }

  getApiEndpointMapper() {
    return this.appSettings.API_ENDPOINT_MAPPER;
  }

  getApiEndpointFunction() {
    return this.appSettings.API_ENDPOINT_EXTERNALFUNCTION;
  }

  getApiEndpointProcess(){
    return this.appSettings.API_ENDPOINT_PROCESS;
  }
  
  getHiperstream3() {
    return this.appSettings.HIPER_STREAM_3;
  }

  getHelpUrl() {
    return this.appSettings.HELP_URL;
  }

  getLoginOnLocalhost() {
    return this.appSettings.ENABLE_LOGIN_ON_LOCALHOST;
  }

  async loadSettings(): Promise<any> {
    return this.httpClient
      .get<AppSettingsModel>('appSettings.json')
      .toPromise()
      .then((appSettings) => {
        this.appSettings = appSettings;
      });
  }
}
